import { render, staticRenderFns } from "./DriverPaymentSettings.vue?vue&type=template&id=4c9a5508"
import script from "./DriverPaymentSettings.vue?vue&type=script&lang=js"
export * from "./DriverPaymentSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports